import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import ProductListingPage from '../Components/Shop/Allcategory';
import Breadcrumbs from '../Components/banner/New-banner';

function Shoppage (){
    return(
        <>
        <Combaintop/>
        <Breadcrumbs/>
        <ProductListingPage/>
        <Combainbottom/>
        </>
    );
}
export default Shoppage;